"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { navItems } from "@data";
import { useState } from "react";
import { Button } from "@heroui/react";
import { Menu, X } from "lucide-react";
import ThemeToggle from "./theme-toggle";
import { useRouter } from "next/navigation";
import { AnimatePresence, motion } from "framer-motion";
const DURATION = 2.0;
const REPEAT_DELAY = 5.0;
const pseudoRandom = (seed: number) => {
  const x = Math.sin(seed + 1) * 10000;
  return x - Math.floor(x);
};
const Header = () => {
  const $ = _c(30);
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  if ($[0] !== router) {
    t0 = url => {
      router.push(url);
      setIsOpen(false);
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onNavItemPress = t0;
  const t1 = isOpen ? "Close navigation menu" : "Open navigation menu";
  let t2;
  let t3;
  if ($[2] !== isOpen) {
    t2 = () => setIsOpen(!isOpen);
    t3 = isOpen ? <X /> : <Menu />;
    $[2] = isOpen;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = <Button aria-label={t1} className="flex md:hidden" variant="ghost" onPress={t2}>{t3}</Button>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Button className="flex items-center gap-0" size="lg" variant="ghost"><Image alt="Logo" height={48} priority={true} src="/icon.webp" width={48} /><span className="text-accent text-xl font-semibold">MrKJOfficial</span></Button>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <div className="flex items-center justify-center gap-1">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== onNavItemPress) {
    t7 = navItems.map((navItem, index) => {
      const Icon = navItem.icon;
      const initialDelay = pseudoRandom(index) * 8;
      return <motion.li key={navItem.label} initial={{
        opacity: 0,
        x: -16
      }} animate={{
        opacity: 1,
        x: 0
      }} whileHover={{
        y: -5,
        scale: 1.03
      }} whileTap={{
        scale: 0.94
      }} transition={{
        duration: 0.5,
        delay: index * 0.12,
        ease: "easeOut"
      }}><Button onPress={() => onNavItemPress(navItem.src)} variant="ghost"><motion.div animate={{
            rotate: [0, 360],
            y: [0, -10, 0]
          }} transition={{
            duration: DURATION,
            repeat: Infinity,
            repeatType: "reverse",
            repeatDelay: REPEAT_DELAY,
            delay: initialDelay,
            ease: "easeInOut"
          }}><Icon size={16} /></motion.div>{navItem.label}</Button></motion.li>;
    });
    $[12] = onNavItemPress;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <ul className="hidden md:flex md:items-center md:justify-center">{t7}</ul>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ThemeToggle />;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8) {
    t10 = <nav className="flex items-center justify-center gap-1">{t8}{t9}</nav>;
    $[17] = t8;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t6) {
    t11 = <div className="flex h-16 w-full items-center justify-between gap-2">{t6}{t10}</div>;
    $[19] = t10;
    $[20] = t6;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== isOpen || $[23] !== onNavItemPress) {
    t12 = isOpen && <motion.nav className="border-border z-10 w-full border-t md:hidden" initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: "auto"
    }} exit={{
      opacity: 0,
      height: 0
    }} transition={{
      duration: 0.3,
      ease: "easeInOut"
    }}><ul className="flex flex-col px-2 py-2">{navItems.map((navItem_0, i) => {
          const Icon_0 = navItem_0.icon;
          const rand = pseudoRandom(i);
          const shouldAnimate = rand > 0.5;
          const initialDelay_0 = rand * 8;
          return <motion.li key={navItem_0.label} initial={{
            opacity: 0,
            x: -16
          }} animate={{
            opacity: 1,
            x: 0
          }} whileHover={{
            x: 5,
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} transition={{
            duration: 0.3,
            delay: i * 0.06,
            ease: "easeOut"
          }}><Button className="flex w-full items-center justify-start gap-2" onPress={() => onNavItemPress(navItem_0.src)} variant="ghost"><motion.div animate={shouldAnimate ? {
                rotate: [0, 360],
                y: [0, -10, 0]
              } : {}} transition={{
                duration: DURATION,
                repeat: Infinity,
                repeatType: "reverse",
                repeatDelay: REPEAT_DELAY,
                delay: initialDelay_0,
                ease: "easeInOut"
              }}><Icon_0 size={16} /></motion.div>{navItem_0.label}</Button></motion.li>;
        })}</ul></motion.nav>;
    $[22] = isOpen;
    $[23] = onNavItemPress;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12) {
    t13 = <AnimatePresence>{t12}</AnimatePresence>;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t11 || $[28] !== t13) {
    t14 = <header className="border-border sticky top-0 z-20 w-full border-b backdrop-blur-sm">{t11}{t13}</header>;
    $[27] = t11;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};
export default Header;